import { FootprintDropdown } from '@lmn/lmn-components';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

const FootprintDropdownContainer = styled.div`
  background-color: white;
  border-radius: 8px;
`;

type Co2FootPrintProps = {
  co2Footprint: CO2Footprint;
} & React.HTMLAttributes<HTMLElement>;

export function Co2FootPrint(props: Co2FootPrintProps) {
  const { co2Footprint, ...rest } = props;
  const { localization } = usePageWrapperData();
  return (
    <FootprintDropdownContainer {...rest}>
      <FootprintDropdown footprint={co2Footprint} locale={localization.locale} />
    </FootprintDropdownContainer>
  );
}
